import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../../utils/contants";

export const StepperNavBackgroundWrapper = styled.div`
  background-color: white;
  padding: 8px 36px 8px 36px;
  border-bottom: 1px solid ${COLOUR_CONSTANT.theme.lightPink};
  display: flex;
  justify-content: space-between;
  margin-bottom: 0 !important;
  height: 52px;
  .flex {
    display: flex;
    gap: 10px;
  }
`;
